import { BRAND_NAME } from '@/lib/branding'
import { cn } from '@/lib/utils'

type BrandLogoSize = 'sm' | 'md' | 'lg'

interface BrandLogoProps {
  size?: BrandLogoSize
  className?: string
  decorative?: boolean
}

const sizeClasses: Record<BrandLogoSize, string> = {
  sm: 'size-8',
  md: 'size-10',
  lg: 'size-12',
}

const sizePixels: Record<BrandLogoSize, number> = {
  sm: 32,
  md: 40,
  lg: 48,
}

export function BrandLogo({
  size = 'md',
  className,
  decorative = false,
}: BrandLogoProps) {
  const pixels = sizePixels[size]

  return (
    <img
      src="/brand/logo-symbol.png"
      alt={decorative ? '' : `${BRAND_NAME} logo`}
      aria-hidden={decorative || undefined}
      width={pixels}
      height={pixels}
      className={cn('shrink-0 rounded-full object-contain', sizeClasses[size], className)}
      loading="eager"
      decoding="async"
    />
  )
}
